<template>
    <page-select v-model="model"
        :options="response || []"
        :loading="loading"
        @search="search"
        data-test="page-select-group">

        <template v-slot:header>
            <slot name="header">Select Groups</slot>
        </template>

        <template v-slot:subheader>
            <slot name="subheader"></slot>
        </template>

        <template v-slot:select-all-right>
            <slot name="select-all-right"></slot>
        </template>

        <template v-slot:option="option">
            <slot name="option"
                v-bind="option">
                <strong> {{ option.item.label || '-' }}</strong>
                - {{ option.item.value }}
            </slot>
        </template>

    </page-select>
</template>

<script setup>
import { inject, onUnmounted } from 'vue';
import { groupsClient } from '~/services';
import { useSearchRequest } from '~/composables/useSearchRequest';
import PageSelect from '~/components/general/PageSelect.vue';
import { GROUP_STATUSES_SENDING } from '~/constants/groupStatuses';

const FEATURES = inject('FEATURES');

const teamId = Spark.state.currentTeam.id;
const model = defineModel({
    type: Array,
    required: true,
});

const props = defineProps({
    filters: {
        type: Object,
        required: false
    },
    statuses: {
        type: Array,
        default: () => GROUP_STATUSES_SENDING,
    },
})

const {
    loading,
    response,
    createSearch,
    cancelSearch,
    cancelKey,
} = useSearchRequest(groupsClient);

const search = createSearch(async (query) => {
    const { data } = await groupsClient.getGroups({ teamId }, {
        query: query,
        ...(FEATURES?.group_statuses
            ? { status: props.statuses }
            : { setup_required: 0 }),
        ...props.filters,
    }, {
        cancelKey: cancelKey,
    });

    return data.data.map((group) => ({
        ...group,
        value: group.group_id,
        label: group.name
    }));
});

// Initialize with empty search
search();

// Clean up on component unmount
onUnmounted(() => {
    cancelSearch({ teamId });
});
</script>
